export default __webpack_public_path__ + "static/media/overall_revenue.2db1bc81.svg";